import { Injectable } from '@angular/core';
import { INavbarModule, INavbarService } from "./sidenavbar.module";

@Injectable({
  providedIn: 'root'
})
export class DataService implements INavbarService {
  private sharedData: any;

  private navModules: INavbarModule[] = [];
  get getNavModules(): INavbarModule[] {
    return this.navModules;
  }

  addNavModule(navModule: INavbarModule) {
    this.navModules.push(navModule);
  }

  constructor() { }

  setData(data: any): void {
  this.sharedData = data;
  setTimeout(() => {
    this.sharedData = []
  },2000)
  }

  // Method to get the data
  getData(): any {
    return this.sharedData;
  }

}
